import * as React from 'react';
import * as classNames from 'classnames';
import './styles.sass';

export interface ISocialIcon {
  className?: string;
  position?: string;
  children?: any;
  type: string;
}

export const IconGroup: React.StatelessComponent<ISocialIcon> = ({
  className,
  position = 'left',
  children,
  type,
}) => {
  const picture = <i
    className={`fa fa-${type} icon-group__picture icon-group__picture_${position}`}
  />;

  return (
    <span className={classNames('icon-group', className)}>
      {position === 'left' && picture}
      {children}
      {position === 'right' && picture}
    </span>
  );
};
